type EnumLike = Record<string, string>;

export function parseEnumValue<TEnum extends EnumLike>(
  enumObject: TEnum,
  value: unknown,
): TEnum[keyof TEnum] | null;
export function parseEnumValue<TEnum extends EnumLike>(
  enumObject: TEnum,
  value: unknown,
  fallback: TEnum[keyof TEnum],
): TEnum[keyof TEnum];
export function parseEnumValue<TEnum extends EnumLike, TFallback>(
  enumObject: TEnum,
  value: unknown,
  fallback: TFallback,
): TEnum[keyof TEnum] | TFallback;
export function parseEnumValue<TEnum extends EnumLike, TFallback>(
  enumObject: TEnum,
  value: unknown,
  fallback: TFallback | null = null,
): TEnum[keyof TEnum] | TFallback | null {
  if (typeof value !== 'string') {
    return fallback;
  }

  return Object.values(enumObject).includes(value as TEnum[keyof TEnum])
    ? (value as TEnum[keyof TEnum])
    : fallback;
}
